var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8121 0.319824H7.2C2.604 0.319824 0 2.92383 0 7.51982V20.1199C0 24.7158 2.604 27.3198 7.2 27.3198H19.8121C24.408 27.3198 27 24.7158 27 20.1199V7.51982C27 2.92383 24.408 0.319824 19.8121 0.319824Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7037 20.09C17.054 20.09 19.77 17.3741 19.77 14.0238C19.77 10.6735 17.054 7.95752 13.7037 7.95752C10.3534 7.95752 7.63745 10.6735 7.63745 14.0238C7.63745 17.3741 10.3534 20.09 13.7037 20.09Z",
    fill: "#CE2600",
    fillOpacity: 0.42
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.7036 18.2437C16.0343 18.2437 17.9236 16.3544 17.9236 14.0237C17.9236 11.6931 16.0343 9.80371 13.7036 9.80371C11.373 9.80371 9.48364 11.6931 9.48364 14.0237C9.48364 16.3544 11.373 18.2437 13.7036 18.2437Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59748 8.64856C8.39703 8.64856 8.23878 8.81208 8.23878 9.00726V10.4262C8.23878 10.5317 8.15438 10.6108 8.05415 10.6108C7.94865 10.6108 7.86953 10.5265 7.86953 10.4262V9.02308C7.86953 8.82791 7.71656 8.65384 7.52138 8.64856C7.31566 8.64329 7.14685 8.80681 7.14685 9.00726V10.4262C7.14685 10.5317 7.06246 10.6108 6.96223 10.6108C6.85673 10.6108 6.77761 10.5265 6.77761 10.4262V9.02308C6.77761 8.82791 6.62463 8.65384 6.42945 8.64856C6.22373 8.64329 6.05493 8.80681 6.05493 9.00726V11.4232C6.05493 11.8993 6.28559 12.3234 6.63982 12.5884C6.95695 12.7673 6.95695 13.5859 6.95695 13.5859V18.8715C6.95695 19.1458 7.1785 19.3673 7.4528 19.3673H7.57413C7.84843 19.3673 8.06998 19.1458 8.06998 18.8715V13.5859C8.06998 13.5859 8.06998 12.7992 8.38711 12.5884C8.74135 12.3234 8.97201 11.8993 8.97201 11.4232V9.00726C8.96146 8.81208 8.79793 8.64856 8.59748 8.64856Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9598 8.64844C20.4346 8.64844 20.8196 9.0335 20.8196 9.50825L20.8196 18.8767C20.8196 19.151 20.598 19.3725 20.3237 19.3725H20.2024C19.9281 19.3725 19.7066 19.151 19.7066 18.8767V14.3312C19.1135 14.063 18.7308 13.4713 18.7308 12.8104V9.88278C18.7255 9.20231 19.2741 8.64844 19.9598 8.64844Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.2f551757ecc237ce62a957f80cbd69b1.svg";
export { ForwardRef as ReactComponent };